const StartPageText = [
    {
      type: "heading",
      eng: "Health tactic and indicator analysis",
      lat: 'Veselības taktiku un indikatoru analīze'
    },
    {
      type: "body",
      eng: (
        <div>
        <p>How to fill the questionnaire?</p>
        <ul>
        <li>Whenever giving an answer to a question, think about your habits of the last month.</li>
        <li>If a question asks about your "usual" or "regular" habits, it means that you follow them 80% of the time.</li>
        <li>It is important that you answer every question, otherwise you will not be able to move on to the next question.</li>
        <li>If you are not sure about your answer, please provide context or a more fitting answer in the comment section.</li>
        <li>By clicking "Next", you will not be able to return to the question, so please take your time to consider your answer, before moving on to the next question.</li>
        </ul>
        </div>
    ),
      lat: (
        <div>
        <p>Kā pildīt anketu?</p>
        <ul>
        <li>Lūdzu, sniedz atbildes uz jautājumiem, domājot par savu ikdienu pēdējā mēneša laikā.</li>
        <li>Ja jautājumā norādīts "parasti" vai "regulāri" tas nozīmē, ka konkrētais apglavojums izpildās vismaz 80% no laika Tavā ikdienā.</li>
        <li>Ir nepieciešams sniegt atbildi uz katru jautājumu, citādāk nevarēsi tikt pie nākamā jautājuma.</li>
        <li>Izmanto komentāru lauciņu, lai sniegtu papildus informāciju vai pierakstītu savas šaubas vai atbilstošāku atbildi.</li>
        <li>Nospiežot uz pogas “tālāk”, vairs nevarēsi atgriezties pie iepriekšējā jautājuma, tāpēc nesteidzies un apdomā atbildi, pirms dodies pie nākamā jautājuma.</li>
        </ul>
        </div>
    ),
    },
  ];

export default StartPageText;